import { makeStyles } from "@material-ui/core"

import { deviceIsMobile } from "@/utils/checkDevice"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	chatAttendantName: {
		fontSize: 10,
		whiteSpace: "nowrap",
		maxWidth: deviceIsMobile() ? "203px" : "262px",
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	chatAttendantIcon: {
		fontSize: 14
	},
	chatTitle: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		maxWidth: "29ch"
	},
	chatTitleName: {
		paddingLeft: theme.spacing(0.5)
	},
	badgeContainer: {
		width: 22,
		height: 22,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: "100%",
		border: `3px solid ${colors.gray[0]}`
	},
	selectedChatListItem: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
	},
	chatListItem: {
		width: "100%",
		height: 87,
		overflow: "hidden"
	},
	chatDescriptionContainer: {
		width: 270,
		wordWrap: "break-word",
		flex: 1,
		maxHeight: 16,
		height: 16,
		"& svg": {
			width: 16,
			height: 16
		},
		"& span": {
			fontSize: 12,
			lineHeight: "16px"
		}
	},
	chatDescription: {
		color: colors.gray[700]
	},
	messageStatus: {},
	chatOptionsButton: {
		minHeight: 24,
		height: 24,
		width: 24,
		boxShadow: "none",
		...ColorUtil.getBackgroundAndContrastColor("transparent")
	},
	chatInfoContainer: {
		width: "auto",
		marginLeft: theme.spacing(1),
		"& > *": {
			cursor: "pointer"
		}
	},
	chatUnreadMessagesText: {
		fontSize: 10,
		marginBottom: theme.spacing(0.5)
	},
	chatListItemContainer: {
		listStyleType: "none"
	},
	chatClientTag: {
		width: 5,
		height: 5,
		borderRadius: "100%"
	},
	snoozeDefined: {
		color: colors.yellow[400],
		marginRight: theme.spacing(0.25)
	},
	snoozeAwakening: {
		color: colors.green[500],
		marginRight: theme.spacing(0.25)
	},
	chatSketch: {
		color: colors.getPrimaryColor()
	},
	metaFreeEntryPointWindowIcon: {
		color: colors.purple[600],
		width: 18,
		height: 18,
		marginLeft: theme.spacing(0.5),
		display: "block"
	},
	metaFreeEntryPointWindowIconExpiring: {
		opacity: 0.45
	}
}))

export default useStyles
